import ExchanageRateService from "../../Services/ExchnageRateService";

export async function fetchRecipientCountryList(accessToken: string): Promise<any[]> {
    const response = await ExchanageRateService.getRecipientCountryList(accessToken);

    if (response?.ok) {
        const result = await response.json();
        console.log(result);
        return result;
    }

    return [];
}

export async function fetchSenderCountryList(accessToken: string): Promise<any[]> {
    const response = await ExchanageRateService.getSenderCountryList(accessToken);

    if (response?.ok) {
        const result = await response.json();
        console.log(result);
        return result;
    }

    return [];
}

export function handleDrawerApplyCommon(
    currentValue: string,
    newValue: string,
    onValueChange: (value: string) => void
) {
    if (currentValue === newValue) {
        console.log("No change in country. Skipping API call.");
        return;
    }
    onValueChange(newValue);
}
